import { SURVEY_SAPPORO, CLOSE_POPUP } from '@/store/actions/survey'

export default {
  data() {
    return {
      style: {},
      htmlEl: document.querySelector("html"),
      uiLayerMask: document.getElementById("uiLayerMask"),
    }
  },
  methods: {
    layerTypeBasic(e) {
      const winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

      const topPosition = winHeight / 2;
      const leftPosition = winWidth / 2;

      const $layerBox = this.$refs.layerBox;
      const targetWidth = $layerBox.clientWidth;
      const targetHeight = $layerBox.clientHeight;

      if (winHeight < 481) {
        this.style = {
          'position': 'absolute',
          'top': '10px',
          'left': '0',
          'right': '0',
          'width': '100%',
          'height': 'auto',
          'margin-top': '0',
          'margin-left': '0',
          'margin-bottom': '12px',
        };
      } else if (targetHeight > winHeight) {
        this.style = {
          'position': 'absolute',
          'top': '3%',
          'left': '0',
          'right': '0',
          'max-width': '98%',
          'height': 'auto',
          'margin': '0 auto',
          'margin-bottom': '3%',
        };
      } else {
        this.style = {
          'top': `${topPosition}px`,
          'left': `${leftPosition}px`,
          'margin-top': `${-(targetHeight / 2)}px`,
          'margin-left': `${-(targetWidth / 2)}px`,
        };
      }
    },
    closePopup() {
      this.$store.dispatch(`${SURVEY_SAPPORO}/${CLOSE_POPUP}`);
    }
  }
}


// WEBPACK FOOTER //
// ./src/views/surveys/sapporo/mixins/PopupMixin.js